import React, { useEffect, useState } from "react";
import {
  FiAlertCircle,
  FiBarChart2,
  FiCheckCircle,
  FiClock,
  FiLink,
  FiRefreshCw,
  FiUsers,
  FiVideo,
  FiYoutube,
} from "react-icons/fi";
import api from "../../utills/api";
import BreadCrumb from "../../Components/Common/BreadCrumb";

import {
  Card,
  Col,
  CardHeader,
  Row,
 
} from "reactstrap";

const INITIAL = {
  connected: false,
  status: "Disconnected",
  channel: null,
  leadCaptureEnabled: false,
  lastSyncAt: null,
  lastError: "",
};

const YouTube = () => {
  const [connection, setConnection] =
    useState(INITIAL);
  const [channel, setChannel] =
    useState(null);
  const [loading, setLoading] =
    useState(true);
  const [actionLoading, setActionLoading] =
    useState(false);
  const [error, setError] =
    useState("");
  const [message, setMessage] =
    useState("");

  const load = async () => {
    try {
      setLoading(true);
      setError("");

      const statusResponse =
        await api.get(
          "/youtube/status"
        );

      const status =
        statusResponse?.data?.data ||
        {};

      setConnection({
        connected:
          Boolean(status.connected),
        status:
          status.status ||
          "Disconnected",
        channel:
          status.channel || null,
        leadCaptureEnabled:
          Boolean(
            status.leadCaptureEnabled
          ),
        lastSyncAt:
          status.lastSyncAt || null,
        lastError:
          status.lastError || "",
      });

      if (status.connected) {
        try {
          const channelResponse =
            await api.get(
              "/youtube/me"
            );

          setChannel(
            channelResponse?.data?.data ||
              null
          );
        } catch (channelError) {
          console.error(
            "YouTube channel load failed:",
            channelError
          );
        }
      } else {
        setChannel(null);
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Unable to load YouTube integration."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

const connect = async () => {
  try {
    setActionLoading(true);
    setError("");
    setMessage("");

    const response = await api.get(
      "/google/oauth/start"
    );

    const authorizationUrl =
      response?.data?.data?.authorizationUrl;

    if (!authorizationUrl) {
      throw new Error(
        "Google authorization URL was not returned."
      );
    }

    window.location.assign(
      authorizationUrl
    );
  } catch (err) {
    console.error(
      "YouTube Google OAuth start failed:",
      err
    );

    setError(
      err?.response?.data?.message ||
        err?.message ||
        "Unable to start Google OAuth."
    );

    setActionLoading(false);
  }
};

  const disconnect = async () => {
    try {
      setActionLoading(true);
      setError("");
      setMessage("");

      await api.post(
        "/youtube/disconnect"
      );

      setMessage(
        "YouTube integration disconnected."
      );

      await load();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Unable to disconnect YouTube."
      );
    } finally {
      setActionLoading(false);
    }
  };

  const formatDate = (value) => {
    if (!value) return "—";

    const date = new Date(value);

    return Number.isNaN(date.getTime())
      ? "—"
      : date.toLocaleString("en-IN", {
          dateStyle: "medium",
          timeStyle: "short",
        });
  };

  const statistics =
    channel?.statistics || {};

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid py-5 text-center">
          <FiRefreshCw
            className="me-2"
            size={20}
          />
          Loading YouTube integration...
        </div>
      </div>
    );
  }

  document.title =
    "YouTube Intigration | eduLeads.Online";

  return (
    <div className="page-content">
      <div className="container-fluid">
               <BreadCrumb
                  title="Youtube Intigration"
                  pageTitle="Intigration"
                />

                 <Row>
          <Col lg={12}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="flex-grow-1">
                    <h5 className="mb-0">
              YouTube Integration
                    </h5>

                    <small className="text-muted">
                      YouTube uses the same Google OAuth
              connection as Google Ads.
                    </small>
                  </div>
                 <button
                  type="button"
                  className="btn btn-light"
                  onClick={load}
                  disabled={actionLoading}
                >
                  <FiRefreshCw
                    className="me-1"
                    size={16}
                  />
                  Refresh
                </button>
                </div>
               
              </CardHeader>
            </Card>
          </Col>
        </Row>
     

        {error && (
          <div className="alert alert-warning d-flex align-items-start">
            <FiAlertCircle
              size={18}
              className="me-2 mt-1"
            />
            <div>{error}</div>
          </div>
        )}

        {message && (
          <div className="alert alert-success d-flex align-items-start">
            <FiCheckCircle
              size={18}
              className="me-2 mt-1"
            />
            <div>{message}</div>
          </div>
        )}

        <div className="card mb-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div
                  className="avatar-sm rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    backgroundColor:
                      "#fce8e6",
                    color: "#ff0000",
                  }}
                >
                  <FiYoutube size={22} />
                </div>

                <div>
                  <h5 className="mb-1">
                    YouTube
                  </h5>

                  <div className="d-flex align-items-center gap-2">
                    {connection.connected ? (
                      <FiCheckCircle
                        size={16}
                        className="text-success"
                      />
                    ) : (
                      <FiClock
                        size={16}
                        className="text-muted"
                      />
                    )}

                    <span>
                      {connection.status}
                    </span>
                  </div>
                </div>
              </div>

              {connection.connected ? (
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={disconnect}
                  disabled={actionLoading}
                >
                  Disconnect
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={connect}
                >
                  <FiLink
                    size={15}
                    className="me-1"
                  />
                  Connect with Google
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title mb-0">
                  Channel Information
                </h5>
              </div>

              <div className="card-body">
                {channel ? (
                  <>
                    <div className="mb-3">
                      <small className="text-muted d-block">
                        Channel Name
                      </small>
                      <strong>
                        {channel?.snippet?.title ||
                          connection.channel
                            ?.name ||
                          "—"}
                      </strong>
                    </div>

                    <div className="mb-3">
                      <small className="text-muted d-block">
                        Channel ID
                      </small>
                      <strong>
                        {channel.id ||
                          connection.channel
                            ?.id ||
                          "—"}
                      </strong>
                    </div>

                    <div>
                      <small className="text-muted d-block">
                        Last Sync
                      </small>
                      <strong>
                        {formatDate(
                          connection.lastSyncAt
                        )}
                      </strong>
                    </div>
                  </>
                ) : (
                  <div className="text-center py-5">
                    <FiYoutube
                      size={36}
                      className="text-muted mb-3"
                    />
                    <h6>
                      No YouTube channel connected
                    </h6>
                    <p className="text-muted mb-0">
                      Connect through Google OAuth
                      to load the channel owned by
                      the Google account.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title mb-0">
                  Channel Statistics
                </h5>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 mb-4">
                    <div className="d-flex align-items-center">
                      <div className="avatar-sm bg-light rounded me-3 d-flex align-items-center justify-content-center">
                        <FiUsers size={20} />
                      </div>
                      <div>
                        <div className="text-muted">
                          Subscribers
                        </div>
                        <h5 className="mb-0">
                          {Number(
                            statistics.subscriberCount ||
                              0
                          ).toLocaleString(
                            "en-IN"
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mb-4">
                    <div className="d-flex align-items-center">
                      <div className="avatar-sm bg-light rounded me-3 d-flex align-items-center justify-content-center">
                        <FiVideo size={20} />
                      </div>
                      <div>
                        <div className="text-muted">
                          Videos
                        </div>
                        <h5 className="mb-0">
                          {Number(
                            statistics.videoCount ||
                              0
                          ).toLocaleString(
                            "en-IN"
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <div className="avatar-sm bg-light rounded me-3 d-flex align-items-center justify-content-center">
                        <FiBarChart2 size={20} />
                      </div>
                      <div>
                        <div className="text-muted">
                          Lead Source
                        </div>
                        <h5 className="mb-0">
                          YouTube
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <div className="avatar-sm bg-light rounded me-3 d-flex align-items-center justify-content-center">
                        <FiClock size={20} />
                      </div>
                      <div>
                        <div className="text-muted">
                          Last Sync
                        </div>
                        <h5 className="mb-0">
                          {formatDate(
                            connection.lastSyncAt
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card mt-4">
          <div className="card-body">
            <h5 className="mb-2">
              Lead Attribution
            </h5>
            <p className="text-muted mb-0">
              Use YouTube campaign links with UTM
              parameters so education leads can be
              attributed to YouTube inside the CRM.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTube;
